import React from 'react';
import Typography from '@mui/material/Typography';

const styles = {
    cellName:{
      fontSize: 14,
      fontWeight: 'bold',
      fontFamily: 'Quicksand'
    },
    cellDetail:{
      fontSize: 14,
      fontFamily:'Quicksand'
    },
    successAlert:{
      backgroundColor: "#57853f",
      width:"95%",
      fontSize: 16,
      fontFamily:'Gilroy'
    },
    rejectAlert:{
      backgroundColor: "#ab3c3c",
      width:"95%",
      fontSize: 16,
      fontFamily:'Gilroy'
    },
    button:{
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: '500',
      fontFamily: 'Quicksand',
      textTransform: 'none',
      color: '#FFFFFF',
      boxShadow: 'none',
      padding: '8px 16px',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center'
    },
    approveText:{
      color: "#57853f",
      fontSize: 16,
      fontFamily: 'Gilroy'
    },
    rejectText:{
      color: "#ab3c3c",
      fontSize: 16,
      fontFamily: 'Gilroy'
    },
    pendingText:{
      color: "#ff8d00",
      fontSize: 16,
      fontFamily: 'Gilroy'
    },
    dateText:{
      fontSize: 14,
      fontFamily: 'Gilroy-Light'
    }
  };
  
  export default styles;
  